import type { EchoflicksSessionMedia } from "../types";
import { isImage } from "./sessionUtils";

/** Pick at most one image on either side, skipping videos between them. */
export const adjacentGalleryImages = (
  items: EchoflicksSessionMedia[],
  activeIndex: number | null,
): EchoflicksSessionMedia[] => {
  if (activeIndex === null || items.length < 2) return [];

  const adjacent: EchoflicksSessionMedia[] = [];
  const seen = new Set<string>();
  for (const direction of [-1, 1]) {
    for (let distance = 1; distance < items.length; distance += 1) {
      const index =
        (activeIndex + direction * distance + items.length) % items.length;
      const candidate = items[index];
      if (!candidate || !isImage(candidate.mime_type)) continue;
      const id = String(candidate.id);
      if (!seen.has(id)) {
        seen.add(id);
        adjacent.push(candidate);
      }
      break;
    }
  }
  return adjacent;
};
